import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    orderDateLabel: translate({ id: 'orders.grid.column.orderDate' }),
    editModeHelperText: translate({ id: 'orders.form.edit.orderDate.helperText' }),
  }))

  return api
}
